import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('wechatnotify/list', { params });
  },
  async add(params: any) {
    return axios.post('wechatnotify/add', qs.stringify(params));
  },
  async edit(params: any) {
    return axios.post('wechatnotify/edit', qs.stringify(params));
  },
  async delete(params: any) {
    return axios.post('wechatnotify/delete', qs.stringify(params));
  },
  async detail(params: any) {
    return axios.get('wechatnotify/detail', { params });
  }
};
